import { JOBS_DELETED_EVENT, JOBS_RETRIED_EVENT, JOBS_SKIPPED_EVENT } from "../../types";
import { request } from "../../utils";
import { locationRestJobResultPost } from "../../wp-api";
async function saveJobResult(id, process, exception) {
    if (exception === void 0) exception = {};
    const { code: errorCode, message: errorMessage, data: errorData } = exception;
    try {
        const result = await request({
            location: locationRestJobResultPost,
            request: {
                process,
                errorCode,
                errorMessage,
                errorData: errorData ? JSON.stringify(errorData) : undefined
            },
            params: {
                id
            }
        });
        if (result.pauseToAvoidRecurringException) {
            await new Promise((resolve)=>{
                const { job: { type } } = result;
                // Wait for user reactivates (delete, retry) the job
                const listenerDeleted = async (param)=>{
                    let { detail: { params: { type: deletedType } } } = param;
                    if (deletedType === type) {
                        document.removeEventListener(JOBS_DELETED_EVENT, listenerDeleted);
                        resolve();
                    }
                };
                const listenerRetried = async (param)=>{
                    let { detail: { request: { type: retriedType } } } = param;
                    if (retriedType === type) {
                        document.removeEventListener(JOBS_RETRIED_EVENT, listenerRetried);
                        resolve();
                    }
                };
                const listenerSkipped = async (param)=>{
                    let { detail: { request: { type: skippedType } } } = param;
                    if (skippedType === type) {
                        document.removeEventListener(JOBS_RETRIED_EVENT, listenerRetried);
                        resolve();
                    }
                };
                document.addEventListener(JOBS_DELETED_EVENT, listenerDeleted);
                document.addEventListener(JOBS_RETRIED_EVENT, listenerRetried);
                document.addEventListener(JOBS_SKIPPED_EVENT, listenerSkipped);
            });
        }
        return result;
    } catch (e) {
        // Something went wrong - but this should not be the case as we should always be able to store
        // job results. Let's wait a bit and try again
        await new Promise((resolve)=>setTimeout(resolve, 60 * 1000));
        return await saveJobResult(id, process, exception);
    }
}
export { saveJobResult };
